<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          " toggleable="lg" type="dark" variant="primary">
          <b-navbar-brand center>Sales Execution Details</b-navbar-brand>
          <!-- <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-form-input :formatter="capitalizeAll"
                class="mr-sm-2"
                v-model="filter"
                @input="viewFFExportFCL('0','1')"
                placeholder="Search"
              ></b-form-input>
          
            </b-nav-form>
          </b-navbar-nav>-->
          <!-- <b-button
                  size="sm"
                  style="margin-left:auto;"
                  class="push-right"
                  @click="viewExportMiscellaneous"
                  variant="outline-danger"
                  >New Miscellaneous</b-button
                > -->
          <Filter-Agency-Modal v-if="$sessionsStorage.get('is_Mobile') != 'port'" />
          <FilterCBModal v-if="$sessionsStorage.get('is_Mobile') != 'port'" />
          <ClientCard />
          <ShipmentTrackCard />
          <b-button @click="goRolloverCont" size="sm" variant="success"
            style="font-size: 0.575rem; margin-left: 5px; margin-bottom: 4px">Rollover Container</b-button>
          <b-button @click="goShipmentTrack" size="sm" variant="success"
            style="font-size: 0.575rem; margin-left: 5px; margin-bottom: 4px">Shipment Track</b-button><br/>
       

          <!-- ($sessionsStorage.get('is_Mobile') != 'port') || -->
        </b-navbar>
        <!-- v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'" -->
        <div>
          <!-- Using modifiers -->
          <!-- <b-button
                variant="outline-dark"
                :class="visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="collapse-4"
                @click="visible = !visible"
          >Filters</b-button>-->
          <b-collapse v-model="visible" id="collapse-2">
            <b-card>
              <md-layout md-gutter>
                <md-layout md-flex="30" md-flex-small="100">
                  <date-range-picker :opens="openLeft" :always-show-calendars="showCal" v-model="dateRange"
                    :startDate="startDate" :endDate="endDate" :locale-data="locale">
                  </date-range-picker>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select :list="clientMaster" id="clientNamenew" v-model="clientIdFilter"
                    option-value="clientId" option-text="clientName"
                    placeholder="Select  Client Name"></model-list-select>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20" md-flex-small="100">
                      <model-list-select
                        :list="jTypeList"
                        v-model="jobTypeFilter"
                        option-value="jTypeVal"
                        option-text="jTypeText"
                        placeholder="Select Job Type "
                      ></model-list-select>
                </md-layout>-->
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select :list="shipmentTypeList" v-model="shipmentTypeFilter"
                    option-value="shipmentTypeVal" option-text="shipmentTypeText"
                    placeholder="Select Sea / Air"></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select :list="flTypeList" v-model="fclLclFilter" option-value="flVal" option-text="flText"
                    placeholder="Select FCL / LCL"></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select :list="transportTypeName" v-model="transportTypeFilter"
                    option-value="transportTypeVal" option-text="transportTypeText"
                    placeholder="Select Export / Import"></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')" :list="finalAllPlaceDataPOR"
                    v-model="PORfilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="Select Place of Receipt"></model-list-select>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')" :list="finalAllPlaceDataPOD"
                    v-model="PODfilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="Select Port of Discharge"></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select @input="getLocationList($event, 'All', 'finalAllPlaceDataLP')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataLP')" :list="finalAllPlaceDataLP"
                    v-model="LPfilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="Select Load Port"></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select :list="containerList" v-model="containerFilter" option-value="containerTypeId"
                    option-text="containerType" placeholder="Select Container Type"></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select :list="shippingList" v-model="shippingFilter" option-value="shippingId"
                    option-text="shippingLine" placeholder="Select Shipping Line"></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <b-form-input :formatter="capitalizeAll" placeholder="Search Enquiry" id="newClientName"
                    name="newClientName" v-model="enquiryFilter"></b-form-input>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <b-form-input :formatter="capitalizeAll" placeholder="Search Assignment" id="newClientName"
                    name="newClientName" v-model="assignmentFilter"></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select :list="$store.getters['commonDropdownMaster/getAllPickupList']"
                    v-model="PICKfilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="Select Pickup Location"></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select :list="$store.getters['commonDropdownMaster/getAllHandoverList']"
                    v-model="HANDfilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="Select Handover Location"></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select :list="$store.getters['commonDropdownMaster/getAllStuffingList']"
                    v-model="STUFFfilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="Select Stuffing Location"></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="30" md-flex-small="100">
                  <b-form-input :formatter="capitalizeAll" placeholder="Container No" id="containerno"
                    name="containerno" v-model="containernoFilter"></b-form-input>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <b-form-input :formatter="capitalizeAll" placeholder="Shipping Bill No." id="shippingbillno"
                    name="shippingbillno" v-model="shippingbillnoFilter"></b-form-input>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <b-form-input :formatter="capitalizeAll" placeholder="Booking No." id="validBookingNo"
                    name="validBookingNo" v-model="validBookingNoFilter"></b-form-input>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout> -->
                <md-layout md-flex="30" md-flex-small="100" class="gutr">
                  <b-form-input :formatter="capitalizeAll" placeholder="Shipper Invocie No." id="continvoiceNo"
                    name="continvoiceNo" v-model="continvoiceNoFilter"></b-form-input>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100" class="gutr">
                  <b-form-input :formatter="capitalizeAll" placeholder="Common Filter" id="commonFilter"
                    name="commonFilter" v-model="commonFilter"></b-form-input>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100" class="gutr">
                  <b-form-input :formatter="capitalizeAll" placeholder="Vessle Filter" id="vessleFilter"
                    name="vessleFilter" v-model="vessleFilter"></b-form-input>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout> -->
                <md-layout md-flex="30" md-flex-small="100" class="gutr">
                  <model-list-select :list="statusList" v-model="statusFilter" option-value="statusVal"
                    option-text="statusText" placeholder="Select Status"></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100" class="gutr">
                  <model-list-select :list="jobList" v-model="jobFilter" option-value="jobVal" option-text="jobText"
                    placeholder="Select Status"></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100" class="gutr">
                  <model-list-select :list="branchList" id="branchfilter" v-model="branchfilter" option-value="pickupId"
                    option-text="pickupLocation" placeholder="All"></model-list-select>
                </md-layout>

                <!-- <md-layout md-flex="30">
                      <model-list-select
                        :list="airlineList"
                        v-model="airlineFilter"
                        option-value="airlineId"
                        option-text="airlineName"
                        placeholder="Select Airline "
                      ></model-list-select>
                </md-layout>-->
              </md-layout>
              <md-layout md-flex="30" class="mt-2 justify-content-center">
                <b-button size="sm" @click="filterSearch" variant="outline-primary">Search</b-button>
                <b-button style="margin-right: 5px" size="sm" class="ml-3" @click="clearFilter"
                  variant="outline-info">clear</b-button>
                <b-button class="mt-2 ml-3" v-if="consoBooking.length > 0"
                  :disabled="ExcelBtnName != 'Export Duplicate Containers' ? true : false" @click="
                    getReportsAss('DuplicateContainers', 'Export Duplicate Containers')
                    " size="sm" variant="outline-info">
                  {{ ExcelBtnName }}
                  <b-spinner v-if="ExcelBtnName != 'Export Duplicate Containers'" small
                    label="Small Spinner"></b-spinner></b-button>

                <b-button class="mt-2 ml-3" v-if="consoBooking.length > 0"
                  :disabled="ExcelBtnName1 != 'Export Exp' ? true : false"
                  @click="getReportsAss('All_Expense_Excel', 'Export Exp')" size="sm" variant="outline-info">
                  {{ ExcelBtnName1 }}
                  <b-spinner v-if="ExcelBtnName1 != 'Export Exp'" small label="Small Spinner"></b-spinner></b-button>

                <b-button class="mt-2 ml-3" v-if="consoBooking.length > 0"
                  :disabled="ExcelBtnName2 != 'Export Add Task' ? true : false"
                  @click="getReportsAss('All_AdditionalTask_Excel', 'Export Add Task')" size="sm"
                  variant="outline-info">
                  {{ ExcelBtnName2 }}
                  <b-spinner v-if="ExcelBtnName2 != 'Export Add Task'" small
                    label="Small Spinner"></b-spinner></b-button>

                <b-button class="mt-2 ml-3" v-if="consoBooking.length > 0"
                  :disabled="ExcelBtnName4 != 'Export Assignments' ? true : false"
                  @click="getSalesAss('All_Sales_Excel', 'Export Assignments')" size="sm" variant="outline-info">
                  {{ ExcelBtnName4 }}
                  <b-spinner v-if="ExcelBtnName4 != 'Export Assignments'" small
                    label="Small Spinner"></b-spinner></b-button>
              </md-layout>
            </b-card>
          </b-collapse>
        </div>
        <div class="mt-2">
          <div>
            <input type="checkbox" @click="SelectAll(consoBooking)" v-model="isCheckAll" />
            <label>Select / Deselect All Count({{ this.AllModule_ids.length }})</label>
            <b-button variant="outline-dark" :class="visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4"
              @click="visible = !visible" style="font-size: 0.575rem; margin-left: 5px; margin-bottom: 4px">Filters</b-button>
                 <userBasedClient v-if="$sessionsStorage.get('userId')"
            :PMC_title="'User Summary - ' + $sessionsStorage.get('employeeName')"
            :PMC_USERID="$sessionsStorage.get('userId')" :PMC_USERNAME="$sessionsStorage.get('nameUser')"
            :PMC_USERDESIG="$sessionsStorage.get('designation')"
            :PMC_BranchClientPre="$sessionsStorage.get('branchclientPre')"
            :PMC_TransportTypePre="$sessionsStorage.get('transportTypePre')"
            :PMC_UserEmpName="$sessionsStorage.get('employeeName')"
            :PMC_UserEmpCode="$sessionsStorage.get('employeeCode')" />
          <b-button v-if="$sessionsStorage.get('is_Mobile') != 'port'" size="sm"
            @click="goToMisc" variant="primary" style="font-size: 0.575rem; margin-left: 5px; margin-bottom: 4px">New Misc Job</b-button>
          <b-button v-if="
            $sessionsStorage.get('designation') == 'Admin' &&
            $sessionsStorage.get('nameUser') == 'Bhavneesh'
          " size="sm" @click="goDeleteRequest" variant="primary" style="font-size: 0.575rem; margin-left: 5px; margin-bottom: 4px">Delete Request</b-button>

          <b-button :disabled="ExcelBtnNameCustom !== 'SI VGM Pending'"
            @click="getReportsCustom('checkJobPendency', 'SI VGM Pending')" size="sm" variant="warning"
           style="font-size: 0.575rem; margin-left: 5px; margin-bottom: 4px">
            {{ ExcelBtnNameCustom }}
            <b-spinner v-if="ExcelBtnNameCustom !== 'SI VGM Pending'" small label="Small Spinner"></b-spinner>
          </b-button>
            <b-button v-if="
              $sessionsStorage.get('designation') == 'Admin' &&
              $sessionsStorage.get('nameUser') == 'Bhavneesh' &&
              AllModule_ids.length > 0
            " size="sm" @click="removeExpInv" variant="outline-primary">Delete Exp/Inv</b-button>

            <h5 class="text-muted pull-right">
              <small v-if="isLoading == false">{{ totalRows }} Entries</small>
            </h5>
          </div>

          <div class="table-responsive tableMain mt-2">
            <b-table :fixed="fixed" show-empty stacked="md" :items="consoBooking" :fields="fields" :per-page="perPage"
              :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
              <template slot="jobType" slot-scope="row0">
                <input v-if="row0.item.allModuleId" type="checkbox" v-bind:value="row0.item.allModuleId"
                  v-bind:id="row0.item.TPTClient" v-model="AllModule_ids"
                  @change="updateSelectAll($event, row0.item)" />
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
              <template slot="mainSalesSeries" slot-scope="row1">
                <md-icon>{{
                  row1.item.shipmentType == "1" ||
                    row1.item.shipmentType == "Sea_Shipment"
                    ? "directions_boat"
                    : "flight_takeoff"
                }}</md-icon>
                <!-- @click="((row1.item.is_locked =='1' &&(row1.item.finalBillingCompleted==1 || row1.item.locked_counter>0) && $sessionsStorage.get('designation') != 'Admin' && $sessionsStorage.get('nameUser') != 'Bhavneesh'))?'':viewExportAirPage(row1.item)" -->
                <!-- && $sessionsStorage.get('designation') != 'Admin' && $sessionsStorage.get('nameUser') != 'Bhavneesh' -->
                <b v-if="$sessionsStorage.get('is_Mobile') == 'port'">{{
                  row1.item.mainSalesSeries
                }}</b>
                <b v-if="$sessionsStorage.get('is_Mobile') != 'port'" class="showMoreData"
                  :disabled="row1.item.asignDeleted == '1'" @click="
                    row1.item.isMiscJob == '1' &&
                      (row1.item.finalBillingCompleted == 1 ||
                        row1.item.all_locked_counter > 0) &&
                      ((row1.item.jobType.indexOf('MISC') >= 0 ||
                        row1.item.jobType.indexOf('YARD') >= 0) && row1.item.is_misc_locked == 1 && (row1.item.finalBillingCompleted == 1 || row1.item.all_locked_counter > 0))
                      ? ''
                      : viewExportFCLConPage(row1.item.allModuleId, row1.item.isMiscJob)
                    ">{{ row1.item.mainSalesSeries }}</b>

                <span v-if="row1.item.rollover_event_code == 1" :class="{
                  alert: true,
                  'alert-danger-text': row1.item.rollover_event_code == 1,
                  blink: row1.item.rollover_event_code == 1,
                }"><br />This Event is Rollover</span>
                <br />
                <span>Assignment Dt. : {{ row1.item.loginTime | moment }}</span>
                <span v-if="row1.item.sub_noti_event_message">Event MSG : {{ row1.item.sub_noti_event_message }}</span>
                <br />
                <span>Job Type : {{ row1.item.jobType }} ({{
                  row1.item.shipmentType == "1" ||
                    row1.item.shipmentType == "Sea_Shipment"
                    ? "Sea"
                    : "Air"
                }}
                  {{ row1.item.transportType }})
                </span>
                <br />

                <span>Raised From : {{ row1.item.baseLoc }}</span><br />
                <span> By : {{ row1.item.raisedBy }}</span><br />

                 <Overseas-CRDRNote
                  v-if="$sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh' && (row1.item.jobType.indexOf('YARD') >= 0||row1.item.jobType.indexOf('IB') >= 0||row1.item.jobType.indexOf('MISC') >= 0)"
                  :title="row1.item.mainSalesSeries"
                  :moduleType="'MISC ' + row1.item.transportType + ' Module'"
                  :cr_all_module_id="String(row1.item.allModuleId)"
                  :cr_jb_series="row1.item.mainSalesSeries"
                  :cr_ass_date="row1.item.loginTime"
                  :transportType="row1.item.transportType"
                  :Jobtype="(row1.item.jobType.indexOf('YARD') >= 0?'YARD':row1.item.jobType.indexOf('IB') >= 0?'IB':row1.item.jobType.indexOf('MISC') >= 0)?'MISC':''"
                  :commonId="''"
                  :shipmentType="row1.item.shipmentType=='2'?'Air':'Sea'"
                  :isOverseas="false"
                  :ItemAr="null"
                />

                <b-button v-if="$sessionsStorage.get('is_Mobile') != 'port'" size="sm" class="mt-2"
                  style="font-size: 0.675rem" @click="showDocModal(row1.item)" variant="outline-info">Summary &
                  Documents</b-button>
                <Assignment-Summary v-if="$sessionsStorage.get('is_Mobile') != 'port'"
                  :title="'Shipment Summary Tracking - '" :assign_date="row1.item.loginTime | moment"
                  :assign_job_type="row1.item.jobType" :assign_raised_from="'Raised From: ' + row1.item.baseLoc"
                  :assign_raised_by="'Raised By: ' + row1.item.raisedBy" :fk_all_module_id="row1.item.allModuleId"
                  :jb_series="row1.item.mainSalesSeries" :fk_client_id="row1.item.clientId"
                  :fk_pod_id="row1.item.PODLocationId" />

                <TimelineModal v-if="row1.item.allModuleId && $sessionsStorage.get('is_Mobile') != 'port'"
                  :PMC_title="'Timeline Summary Job No - ' + row1.item.mainSalesSeries"
                  :PMC_JOBID="row1.item.allModuleId" :PMC_JOBNO="row1.item.mainSalesSeries"
                  :PMC_JOBDATE="row1.item.loginTime | moment" :PMC_JOBTYPE="row1.item.jobType" :PMC_AgentType="''"
                  :PMC_Client="row1.item.TPTClient" :PMC_Sline="row1.item.shippingLine" />
                <!-- {{row1.item}} -->
                <Multi-Update v-if="
                  row1.item.shipmentType != '2' &&
                  $sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh' &&
                  $sessionsStorage.get('is_Mobile') != 'port'
                " :title="'All Update Assignment Detials - '" :mu_assign_date="row1.item.loginTime | moment"
                  :mu_assign_job_type="row1.item.jobType" :mu_assign_raised_from="'Raised From: ' + row1.item.baseLoc"
                  :mu_assign_raised_by="'Raised By: ' + row1.item.raisedBy" :mu_all_module_id="row1.item.allModuleId"
                  :mu_jb_series="row1.item.mainSalesSeries" :mu_client_id="row1.item.clientId"
                  :mu_pod_id="row1.item.PODLocationId" :mu_shipmentType="row1.item.shipmentType"
                  :mu_transportType="row1.item.transportType" :mu_containerInfo="row1.item.containerInfo"
                  :mu_multipleContainerType="row1.item.multipleContainerType" :mu_clientType="row1.item.clientType" />
                
                <b-button v-if="row1.item.shipmentType == '2' && $sessionsStorage.get('is_Mobile') != 'port' &&  $sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh'" size="sm" class="mt-2"
                  style="font-size: 0.675rem" @click="openAirAssignmentModal(row1)" variant="outline-primary">
                  Multi-Update
                </b-button>

                <AirAssignmentModal v-if="row1.item.shipmentType == '2'"
                  :ref="'AirAssignmentModal' + row1.item.allModuleId"
                  :mu_all_module_id="row1.item.allModuleId"
                  :mu_jb_series="row1.item.mainSalesSeries"
                  :mu_assign_job_type="row1.item.jobType"
                  :mu_enq_job_type="row1.item.EnqJob"
                  :mu_client_id="row1.item.clientId"
                  :mu_item="row1.item"
                  @refresh="viewFFExportFCL('0', '1', '1')" />
                <!-- {{row1.item}} -->
                <!-- {{row1.item}} -->
                <CommonLock v-if="
                  row1.item.jobType.indexOf('MISC') >= 0 ||
                  (row1.item.jobType.indexOf('YARD') >= 0 &&
                    $sessionsStorage.get('is_Mobile') != 'port')
                " :title="'Lock and Un-Lock Pannel - '" :lock_assign_date="row1.item.loginTime | moment"
                  :lock_assign_job_type="row1.item.jobType"
                  :lock_assign_raised_from="'Raised From: ' + row1.item.baseLoc"
                  :lock_assign_raised_by="'Raised By: ' + row1.item.raisedBy"
                  :lock_all_module_id="row1.item.allModuleId" :lock_jb_series="row1.item.mainSalesSeries"
                  :lock_client_id="row1.item.clientId" :lock_pod_id="row1.item.PODLocationId"
                  :lock_shipmentType="row1.item.shipmentType" :lock_transportType="row1.item.transportType"
                  :lock_containerInfo="row1.item.containerInfo"
                  :lock_multipleContainerType="row1.item.multipleContainerType" :lock_clientType="row1.item.clientType"
                  :lock_ff_is_locked="row1.item.ff_is_locked" :lock_tpt_is_locked="row1.item.tpt_is_locked"
                  :lock_cc_is_locked="row1.item.cc_is_locked" :lock_consoli_is_locked="row1.item.consoli_is_locked"
                  :lock_all_locked_counter="row1.item.all_locked_counter"
                  :lock_all_lock_date_time="row1.item.all_lock_date_time"
                  :lock_extra_payment_count="row1.item.extra_payment_count"
                  :lock_finalBillingCompleted="row1.item.finalBillingCompleted" :lock_item="row1.item"
                  :lock_is_misc_locked="row1.item.is_misc_locked == 0 || row1.item.is_misc_locked == 1
                      ? row1.item.is_misc_locked
                      : row1.item.isMiscJob
                    " />
                <!-- {{row1.item}} -->
                <InvExpSummary v-if="row1.item.allModuleId"
                  :PMC_title="'Inv Exp Summary Job No - ' + row1.item.mainSalesSeries"
                  :PMC_JOBID="row1.item.allModuleId" :PMC_JOBNO="row1.item.mainSalesSeries"
                  :PMC_JOBDATE="row1.item.loginTime | moment" :PMC_JOBTYPE="row1.item.jobType" :PMC_AgentType="''"
                  :PMC_Client="row1.item.TPTClient" :PMC_Sline="row1.item.shippingLine" />
                <ContainerSummary v-if="row1.item.allModuleId"
                  :PMC_title="'Container Summary Job No - ' + row1.item.mainSalesSeries"
                  :PMC_JOBID="row1.item.allModuleId" :PMC_JOBNO="row1.item.mainSalesSeries"
                  :PMC_JOBDATE="row1.item.loginTime | moment" :PMC_JOBTYPE="row1.item.jobType" :PMC_AgentType="''"
                  :PMC_Client="row1.item.TPTClient" :PMC_Sline="row1.item.shippingLine" />
                <AssignmentSplitMergeSummary v-if="row1.item.allModuleId"
                  :PMC_title="'Assignment Split/Merge/Move Summary Job No - ' + row1.item.mainSalesSeries"
                  :PMC_JOBID="row1.item.allModuleId" :PMC_JOBNO="row1.item.mainSalesSeries"
                  :PMC_JOBDATE="row1.item.loginTime | moment" :PMC_JOBTYPE="row1.item.jobType" :PMC_AgentType="''"
                  :PMC_Client="row1.item.TPTClient" :PMC_Sline="row1.item.shippingLine" />
                <RejectInvTallyBillSummary v-if="row1.item.allModuleId" :PMC_title="'Invoice Rejection Log Summary Job No - ' + row1.item.mainSalesSeries
                  " :PMC_JOBID="row1.item.allModuleId" :PMC_JOBNO="row1.item.mainSalesSeries"
                  :PMC_JOBDATE="row1.item.loginTime | moment" :PMC_JOBTYPE="row1.item.jobType"
                  :PMC_Client="row1.item.TPTClient" :PMC_Sline="row1.item.shippingLine" />
                <JobWisePaymentsDetails v-if="row1.item.allModuleId" :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.mainSalesSeries" />
                <BookingTrack
                  v-if="row1.item.newfreightContainers && row1.item.jobType.indexOf('FF') >= 0 && row1.item.SubscriptionId"
                  :containerArr="row1.item.newfreightContainers" :slineName="row1.item.shippingLine"
                  :clientName="row1.item.TPTClient"
                  :modal_title="`Container Movement Booking No: ${row1.item.validBookingNo} Job No - ${row1.item.mainSalesSeries} Client: ${row1.item.TPTClient}`"
                  :JOBNO="row1.item.mainSalesSeries" :shipment_id="Number(0)" :subscription_id="Number(0)"
                  :fk_sub_track_id="Number(0)" :fk_all_module_id="Number(row1.item.allModuleId)"
                  :fk_booking_id="Number(row1.item.fk_booking_id)" :fk_container_id="Number(0)"
                  :booking_number="row1.item.validBookingNo" :container_number="''" />

                <br />
                <h7 class="mt-2" v-if="row1.item.splitFromId != '0'"><b-badge variant="info">Split of {{
                  row1.item.splitFromNo }}</b-badge>
                </h7>
                <!-- {{row1.item}} -->
                <Splitmerge-Summary :title="'Split & Merge Track - '" :SM_all_module_id="row1.item.allModuleId"
                  :SM_jb_series="row1.item.mainSalesSeries" :SM_Status="1" class="mt-2" v-if="
                    row1.item.SplitedStatus != '0' &&
                    $sessionsStorage.get('is_Mobile') != 'port'
                  " />
                <h6>
                  <b-badge variant="danger" v-if="row1.item.asignDeleted == '1'">Assignment Deleted</b-badge>
                </h6>
              </template>
              <template slot="TPTClient" slot-scope="row11">
                <b v-if="
                  row11.item.clientType == '3' && row11.item.transportType == 'Export'
                ">
                  Client Name : {{ row11.item.exporter }}
                  <br />
                </b>
                <b v-if="row11.item.clientType == '3'">
                  Overseas Agent : {{ row11.item.TPTClient }}
                  <br />
                </b>
                <b v-if="row11.item.clientType != '3'">
                  {{ row11.item.TPTClient }}
                  <br />
                </b>
              </template>
              <template v-if="row2.item.EnqJob" slot="mainEnquirySeries" slot-scope="row2">
                <!-- {{ row2.item }} -->
                <b style="color: blue" @click="viewExportEnqPage(row2.item.mainEnquiryId)" class="showMoreData"><u>{{
                  row2.item.mainEnquirySeries }}</u></b>
                <!-- <span>{{ row2.item.mainEnquirySeries }}</span> -->
                <br />
                <span>Enquiry Type : {{ row2.item.EnqJob }} ({{
                  row2.item.shipmentType == "1" ? "Sea" : "Air"
                }}
                  {{ row2.item.transportType }})</span>
                <br />
                <span>Enquiry Date : {{ row2.item.enqDate | moment }}</span>
              </template>
              <template slot="POR" slot-scope="row7">
                <div v-if="
                  row7.item.shipmentType == '1' ||
                  row7.item.shipmentType == 'Sea_Shipment'
                ">
                  <span>Container Type : {{ row7.item.multipleContainerType }}</span>
                  <br />
                  <span>No of Containers : {{ row7.item.multiConNo }}</span>
                  <br />

                  <span :style="row7.item.SubscriptionId ? 'color: blue;font-weight:bold' : ''
                    " @click="
                      row7.item.SubscriptionId ? goToSubscriptionPage(row7.item) : ''
                      ">Booking No : {{ row7.item.validBookingNo }}</span><br />
                  <span>Shipper INV No : {{ row7.item.shipperInvoiceNo }}</span><br />
                  <span v-if="
                    row7.item.newContainerFlow == '1' &&
                    row7.item.shipmentType == '1' &&
                    parseInt(row7.item.multiConNo) !=
                    parseInt(row7.item.amendmentContainersCount)
                  " class="error"><b>Amendment Containers: {{ row7.item.amendmentContainersCount }}</b><br /></span>
                  <span>Shipping Line : {{ row7.item.shippingLine }}</span>
                  <br />
                  <span>Pickup : {{ row7.item.pickup }}</span>
                  <br />
                  <span>Stuffing : {{ row7.item.stuffingLoc }}</span>
                  <br />
                  <span>Handover : {{ row7.item.handover }}</span>
                  <br />
                  <span>Place of Receipt : {{ row7.item.POR }}</span>
                  <br />
                  <div v-if="row7.item.jobType.split(',').includes('FF')">
                    <span>Load Port : {{ row7.item.LP }}</span>
                    <br />
                    <span>Port of Discharge : {{ row7.item.POD }}</span>
                    <br />
                    <span>Final Place of Delivery : {{ row7.item.finalPlace }}</span>
                  </div>
                </div>
                <div v-else>
                  <span>
                    Departure Airport : {{ row7.item.AirDept }}
                    <br />
                  </span>
                  <span>
                    Destination Airport : {{ row7.item.airDesti }}
                    <br />
                  </span>
                  <span>
                    No.of Packages : {{ row7.item.noOfPkg }}
                    <br />
                  </span>
                  <span>
                    Cargo Received At :
                    {{ row7.item.cargoReceived == "1" ? "Airport" : "Warehouse" }}
                    <br />
                  </span>
                </div>
              </template>

              <!-- <template slot="allModuleId" slot-scope="row9">
                <md-button
                  :disabled="row9.item.asignDeleted=='1'"
                  @click="viewExportFCLConPage(row9.item.allModuleId)"
                >
                  <a class="fa fa-pencil-square-o"></a>
                </md-button>
              </template>-->
              <template slot="deleteRequest" slot-scope="row10">
                <td>
                  <b style="color: red" v-if="
                    row10.item.deleteRequest == '0' &&
                    $sessionsStorage.get('is_Mobile') != 'port'
                  " class="showMoreData" @click="
                      CompleteRemoveASS(
                        row10.item.allModuleId,
                        '1',
                        row10.item.mainSalesSeries
                      )
                      ">Request To Delete Assignment</b>
                  <!-- execActions(row10.item.allModuleId, '1', row10.item.mainSalesSeries) -->
                  <br v-if="
                    row10.item.deleteRequest == '0' &&
                    $sessionsStorage.get('is_Mobile') != 'port'
                  " />
                  <b style="color: red" v-if="
                    row10.item.deleteRequest == '1' &&
                    row10.item.ApproveRejectDelReq == '0' &&
                    ($sessionsStorage.get('designation') == 'manager' ||
                      $sessionsStorage.get('designation') == 'employee')
                  ">Sent For Delete Approval</b>

                  <br v-if="
                    row10.item.deleteRequest == '1' &&
                    row10.item.ApproveRejectDelReq == '0' &&
                    ($sessionsStorage.get('designation') == 'manager' ||
                      $sessionsStorage.get('designation') == 'employee') &&
                    $sessionsStorage.get('is_Mobile') != 'port'
                  " />

                  <!-- execActions(row10.item.allModuleId, '2', row10.item.mainSalesSeries) -->
                  <b @click="
                    CompleteRemoveASS(
                      row10.item.allModuleId,
                      '2',
                      row10.item.mainSalesSeries
                    )
                    " style="color: red" v-if="
                      row10.item.deleteRequest == '1' &&
                      row10.item.ApproveRejectDelReq != '2' &&
                      ($sessionsStorage.get('designation') == 'Admin' ||
                        $sessionsStorage.get('designation') == 'HOD') &&
                      $sessionsStorage.get('is_Mobile') != 'port'
                    " class="showMoreData">Approve Delete Request /</b>

                  <!-- execActions(row10.item.allModuleId, '3', row10.item.mainSalesSeries) -->
                  <b @click="
                    CompleteRemoveASS(
                      row10.item.allModuleId,
                      '3',
                      row10.item.mainSalesSeries
                    )
                    " style="color: red" v-if="
                      row10.item.deleteRequest == '1' &&
                      row10.item.ApproveRejectDelReq != '2' &&
                      $sessionsStorage.get('is_Mobile') != 'port'
                    " class="showMoreData">Reject Delete Request</b>
                  <br v-if="
                    row10.item.deleteRequest == '0' &&
                    row10.item.ApproveRejectDelReq != '2' &&
                    $sessionsStorage.get('is_Mobile') != 'port'
                  " />
                  <b @click="
                    CompleteRemoveASS(
                      row10.item.allModuleId,
                      '4',
                      row10.item.mainSalesSeries
                    )
                    " style="color: red" v-if="
                      row10.item.ApproveRejectDelReq == '2' &&
                      row10.item.asignDeleted != '1' &&
                      $sessionsStorage.get('is_Mobile') != 'port'
                    " class="showMoreData">Delete Assignment</b>

                  <!-- execActions(row10.item.allModuleId, '4', row10.item.mainSalesSeries) -->

                  <b style="color: red" v-if="row10.item.asignDeleted == '1'"></b>
                  <b style="color: red" v-if="
                    row10.item.deleteRequest == '1' &&
                    row10.item.ApproveRejectDelReq == '0' &&
                    ($sessionsStorage.get('designation') == 'manager' ||
                      $sessionsStorage.get('designation') == 'employee')
                  ">Sent For Delete Approval</b>
                  <br />
                  <!-- {{row10.item}} -->
                  <b v-if="
                    row10.item.deleteRequestBy != '' &&
                    row10.item.deleteRequestBy != '0' &&
                    row10.item.deleteRequestBy != null
                  ">Requested By : {{ row10.item.deleteRequestBy }}<br /></b>
                  <!-- {{row10.item.finalBillingCompleted}} -->
                  <b-button style="font-size: 0.675rem" class="mt-2 mb-1x" v-if="
                    row10.item.finalBillingCompleted != '1' &&
                    $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('is_Mobile') != 'port'
                  " size="sm" @click="closeBillModal(row10.item.allModuleId, row10.item.jobType)"
                    variant="outline-info">Close Billing</b-button>
                  <span v-if="
                    row10.item.finalBillingCompleted == '1' &&
                    row10.item.assignmentCloseReason
                  " style="color: green" v-html="row10.item.assignmentCloseReason">{{
                    wordWrap(row10.item.assignmentCloseReason, 24) }}</span>
                  <span v-if="
                    row10.item.fk_loss_job_user_id &&
                    row10.item.known_loss_job_remark
                  " v-html="row10.item.known_loss_job_remark">{{ wordWrap(row10.item.known_loss_job_remark, 24) }}
                    <br /></span>
                  <span v-if="
                    row10.item.fk_loss_job_user_id &&
                    row10.item.known_loss_job_remark
                  ">User Name:{{ row10.item.loss_job_user }}<br />Loss Job Date:{{ row10.item.known_loss_job_date
                    }}<br /></span>
                  <!-- closeBillModal() -->
                  <Add-Message v-if="$sessionsStorage.get('is_Mobile') != 'port'"
                    :fk_all_module_id="row10.item.allModuleId" :fk_client_id="row10.item.clientId"
                    :fk_pod_id="row10.item.PODLocationId" style="list-style-type: none" />

                  <!-- {{row10.item.finalBillingCompleted}} -->
                  <b-button style="font-size: 0.675rem" class="mt-2" size="sm" @click="
                    PortExpense(row10.item.allModuleId, row10.item.jobType, row10.item)
                    " variant="outline-info">Port Expense</b-button>
                </td>
              </template>

              <template slot="action" slot-scope="row3">
                <!-- <h6>
                  <b-badge
                    :variant="row3.item.isAllActive==1?'success':'danger'"
                  >{{row3.item.isAllActive==1?"Active":"In-Active" }}</b-badge>
                </h6> -->

                <div v-if="adminToggle == 'Admin' && row3.item.asignDeleted == 1" :id="'row' + row3.item.allModuleId">
                  <md-switch :id="'approval' + row3.item.allModuleId" name="approval" class="md-primary"
                    :value="row3.item.asignDeleted == 1 ? true : false" @change="activateUserMultiple(row3.item)">
                    <h6>
                      <br />
                      <b-badge style="margin-left: -45px">{{
                        row3.item.asignDeleted == 1 ? "Deleted" : "Not Deleted"
                      }}</b-badge>
                    </h6>
                  </md-switch>
                </div>
              </template>
            </b-table>
          </div>
        </div>

        <div>
          <h5>
            <div>
              <b-pagination imit="5" align="center" v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
                @change="onPageChange($event)"></b-pagination>
            </div>
          </h5>
        </div>
      </b-card-text>
    </b-card>
    <div>
      <b-modal class="modal-dialog-doc" size="xl" no-close-on-esc no-close-on-backdrop ref="doc-modal" hide-footer
        :title="'Assignment Summary & Documents - ' + JOBSERIES">
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal">Close
        </b-button>
      </b-modal>

      <!-- Added By Priyanshu Singh For Billing Close Section Start -->
      <b-modal id="modal-close-conf" ref="modal-close-conf" title="Reason for Closing Assignment Billing" centered
        no-close-on-esc no-close-on-backdrop hide-footer>
        <h3>Confirmation</h3>
        <form ref="form">
          <b-form-group label="Remark" label-for="name-input" invalid-feedback="Name is required">
            <b-form-textarea :formatter="capitalizeAll" rows="5" id="name-input" v-model="billingclosingReason"
              required></b-form-textarea>
          </b-form-group>
        </form>
        <b-button :disabled="billingclosingReason ? false : true" variant="success" @click="closeBillOk">
          Confirm & Close Billing</b-button>
        <b-button @click="closeModalConfirm" variant="danger" class="pull-right">
          Cancel</b-button>
      </b-modal>
      <!-- Added By Priyanshu Singh For Billing Close Section End -->
    </div>

    <b-modal id="modal-INVEXP-conf" ref="modal-INVEXP-conf" title="Confirmation Remove Invoice Expenses Choose Option"
      centered no-close-on-esc no-close-on-backdrop hide-footer>
      <b-row>
        <b-col md="12" align="center">
          <b-button style="font-size: 0.675rem" class="mt-2 mb-5 mt-1" size="sm" v-model="DeleteType"
            :variant="DeleteType == 'Exp' ? 'success' : 'outline-info'"
            @click="DeleteTypeFunc('Exp')">Expense</b-button>
          <b-button style="font-size: 0.675rem" class="mt-2 mb-5 mt-1" size="sm" v-model="DeleteType"
            :variant="DeleteType == 'Inv' ? 'success' : 'outline-info'"
            @click="DeleteTypeFunc('Inv')">Invocie</b-button>
          <b-button style="font-size: 0.675rem" class="mt-2 mb-5 mt-1" size="sm" v-model="DeleteType"
            :variant="DeleteType == 'Both' ? 'success' : 'outline-info'" @click="DeleteTypeFunc('Both')">Both</b-button>
        </b-col>
      </b-row>
      <b-button style="font-size: 0.675rem" :disabled="DeleteType ? false : true" variant="success"
        @click="CompleteRemoveExpInv">
        Confirm & Remove</b-button>
      <b-button style="font-size: 0.675rem" @click="closeModalRemoveExpInv" variant="danger"
        class="pull-right">Close</b-button>
    </b-modal>

    <b-modal id="modal-AssRemove-conf" ref="modal-AssRemove-conf" title="Confirmation Remove Assignment" centered
      no-close-on-esc no-close-on-backdrop hide-footer>
      <b-row>
        <b-col md="12" align="center" class="error">
          <h5>{{ PaymentType }}</h5>
        </b-col>
      </b-row>

      <b-button style="font-size: 0.675rem" @click="closeModalRemoveAss" variant="danger"
        class="pull-left">No</b-button>
      <b-button style="font-size: 0.675rem" variant="success" class="pull-right"
        @click="execActions(PaymentTypeModuleId, PaymentTypeID, PaymentTypeJOBNo)">
        Yes</b-button>
    </b-modal>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onCloseAction"
      ref="addPopMail"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onCloseAction"
      ref="addPopApprove"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onCloseAction"
      ref="addPopReject"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onCloseAction"
      ref="addPopDelete"></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import DateRangePicker from "vue2-daterange-picker";
import CustomLoader from "../common/customLoader.vue";
import {
  lastVisitPage,
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";
import DocForm from "../allModuleForm/docLibrary.vue";
import AddMessage from "../allModuleForm/addMessage.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import SplitmergeSummary from "../common/splitmergeSummary.vue";
import MultiUpdate from "../common/multiUpdate.vue";
import AirAssignmentModal from "../common/AirAssignmentModal.vue";
import CommonLock from "../common/commonLock.vue";
import MasterService from "../../services/MasterService.js";
import CommonService from "../../services/CommonService.js";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
import userBasedClient from "../common/userBasedClient.vue";
import BookingTrack from "../consoleBooking/bookingTrack.vue";
import { exportJobListToExcel } from "../../helper/ExcelExportHelper.js";
import OverseasCRDRNote from "../common/overseasCRDRNote.vue"; 
import TimelineModal from "../common/TimelineModal.vue";

export default {
  beforeMount() {
    this.$store.dispatch(
      "commonDropdownMaster/setAllPickupDDList",
      JSON.stringify({
        itemCode: "AllPickupList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllStuffingDDList",
      JSON.stringify({
        itemCode: "AllStuffingList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllHandoverDDList",
      JSON.stringify({
        itemCode: "AllHandoverList",
      })
    );
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/viewConsoBooking");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      ExcelBtnNameCustom: "SI VGM Pending",
      invnoErrFlag: false,
      PaymentType: "",
      PaymentTypeModuleId: "",
      PaymentTypeID: "",
      PaymentTypeJOBNo: "",
      //Added By Priyanshu Singh Multi Select Start
      DeleteType: "",
      isCheckAll: false,
      AllModule_ids: [],
      AllJob_Nos: [],
      selectedAllModule_ids: "",
      selectedClient_ids: "",

      openLeft: "right",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      billingclosingReason: "",
      billingclosingAllModuleId: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      finalAllPlaceDataPOR: [],
      finalAllPlaceDataPOD: [],
      finalAllPlaceDataLP: [],
      commodityList: [],
      airlineList: [],
      containerList: [],
      shippingList: [],
      clientTypeFilter: "",
      clientIdFilter: "",
      transportTypeFilter: "",
      shipmentTypeFilter: "",
      jobTypeFilter: "",
      enqOrExuFilter: "",
      PORfilter: "",
      PODfilter: "",
      LPfilter: "",
      PICKfilter: "",
      HANDfilter: "",
      STUFFfilter: "",
      commodityFilter: "",
      shippingFilter: "",
      enquiryFilter: "",
      assignmentFilter: "",
      containernoFilter: "",
      shippingbillnoFilter: "",
      validBookingNoFilter: "",
      continvoiceNoFilter: "",
      commonFilter: "",
      vessleFilter: "",
      fclLclFilter: "",
      statusFilter: "3",
      jobFilter: "All",
      branchfilter: this.branchfilter,
      airlineFilter: "",
      containerFilter: "",
      jTypeList: [
        {
          jTypeVal: "TPT",
          jTypeText: "TPT",
        },
        {
          jTypeVal: "FF",
          jTypeText: "FF",
        },
        {
          jTypeVal: "CC",
          jTypeText: "CC",
        },
      ],
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],
      shipmentTypeList: [
        {
          shipmentTypeVal: "1",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "2",
          shipmentTypeText: "Air",
        },
      ],
      statusList: [
        {
          statusVal: "1",
          statusText: "Active",
        },
        {
          statusVal: "2",
          statusText: "In-Active",
        },
        {
          statusVal: "3",
          statusText: "All",
        },
      ],
      jobList: [
        {
          jobVal: "FF",
          jobText: "FF",
        },
        {
          jobVal: "CC",
          jobText: "CC",
        },
        {
          jobVal: "TPT",
          jobText: "TPT",
        },
        {
          jobVal: "All",
          jobText: "All",
        },
      ],
      branchList: [],
      branchfilter: "",
      flTypeList: [
        {
          flVal: "fcl",
          flText: "FCL",
        },
        {
          flVal: "lcl",
          flText: "LCL",
        },
      ],
      ALLMODULE: "",
      JOBSERIES: "",
      reload: true,
      clientMaster: [],
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 10,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      is_custom_excel: "0",
      generateExcel: "0",
      fields: [
        {
          key: "jobType",
          mainkey: "jobType",
          label: "Sr No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "TPTClient",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "mainEnquirySeries",
          mainkey: "mainEnquirySeries",
          label: "Enquiry No.",
          sortable: true,
          sortDirection: "ASC",
          table: "Z.",
        },
        {
          key: "POR",
          mainkey: "POR",
          label: "Assignment Details",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },
        // {
        //   key: "isAllActive",
        //   mainkey: "isAllActive",
        //   label: "Split / Merge Details",
        //   sortable: true,
        //   sortDirection: "ASC"
        //   //  table: "B."
        // },
        {
          key: "action",
          label: "status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "deleteRequest",
          mainkey: "deleteRequest",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          class: "text-center",
          //  table: "B."
        },

        // {
        //   key: "allModuleId",
        //   mainkey: "allModuleId",
        //   label: "View",
        //   sortable: true,
        //   sortDirection: "ASC"
        // }
      ],
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      eventId: "",
      mailallModuleId: "",
      mailExecSeries: "",
      isLoading: false,
      visible: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      fixed: true,
      consoBooking: [],
      ExcelBtnName: "Export Duplicate Containers",
      ExcelBtnName1: "Export Exp",
      ExcelBtnName2: "Export Add Task",
      ExcelBtnName4: "Export Assignments",
      generateExcel: "0",

      indexNew: "",
      deleteId: "",
      itemObj: {},
      adminToggle: this.$sessionsStorage.get("designation"),
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    DocForm,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
    AddMessage,
    AssignmentSummary,
    SplitmergeSummary,
    MultiUpdate,
    AirAssignmentModal,
    DateRangePicker,
    CustomLoader,
    CommonLock,
    InvExpSummary,
    ContainerSummary,
    RejectInvTallyBillSummary,
    JobWisePaymentsDetails,
    AssignmentSplitMergeSummary,
    userBasedClient,
    BookingTrack,
    OverseasCRDRNote,
    TimelineModal,
  },

  computed: {},

  methods: {

    getReportsCustom(id, btnName) {
      this.isLoading = true;
      this.is_custom_excel = "1";
      this.generateExcel = "1";
      this.ExcelBtnNameCustom = "Downloading Please Wait .....";
      this.getCommonBLPendencyList("Excell", "0", "0", "1", "1");
    },
    getCommonBLPendencyList(type, filterId, currentPage, searchType, pageNumber) {
      this.totalData = 0;
      this.JOBList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getBookingResp",
        type: type,
        filter: {
          branchFilter: this.branchfilter,
          createdAtRange: this.dateRange,
        },
        generateExcel: this.generateExcel,
        is_custom_excel: this.is_custom_excel,
        record_type: "",
        is_client_template: 1,
        
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getAllCommonJobList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", data);

          if (status == 200 && data) {
            if (this.generateExcel == "1") {

              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Job-Pendency-panel-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.ExcelBtnNameCustom = "SI VGM Pending";
              this.generateExcel = "0";
              this.is_custom_excel = "0";
              this.getCommonBLPendencyList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.pagination.total;
                this.JOBList = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getBookingResp Error: ", error);
        });
    },
    PortExpense(allModuleId, JobType, item) {
      this.$sessionsStorage.set("port_allModuleId", "");
      this.$sessionsStorage.set("port_JOBSERIES", "");
      this.$sessionsStorage.set("port_JOBType", "");
      this.$sessionsStorage.set("port_allModuleId", allModuleId);
      this.$sessionsStorage.set("port_JOBSERIES", item.mainSalesSeries);
      this.$sessionsStorage.set("port_JOBType", JobType);
      this.$router.push({
        path: "/allModule/portExpenses",
      });
    },
    wordWrap,
    closeBillOk(type) {
      // this.billingclosingReason = "Direct Close InVoices Done";

      if (this.billingclosingReason) {
        this.isLoading = true;
        let payload = {
          allModuleId: this.billingclosingAllModuleId,
          closingReason: this.billingclosingReason,
        };
        // console.log(payload);return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_TallyBilling/closeBillingStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.viewFFExportFCL("0", "1", "1");
              this.isLoading = false;
            }
            (this.billingclosingReason = ""), this.$refs["modal-close-conf"].hide();
          })
          .catch((error) => { });
      }
    },
    closeBillModal(allModuleId, jobType) {
      console.log("allModuleId=>", allModuleId);
      console.log("jobType=>", jobType);
      this.billingclosingAllModuleId = "";
      this.billingclosingAllModuleId = allModuleId;
      this.$refs["modal-close-conf"].show();
    },
    closeModalConfirm() {
      this.$refs["modal-close-conf"].hide();
    },
    goToMisc() {
      this.$sessionsStorage.set("editSalesExId", "");
      this.$sessionsStorage.set("editMainEnqId", "");
      this.$router.push({
        path: "/mainEnquiry/miscSalesExecutionAll",
      });
    },
    goDeleteRequest() {
      this.$sessionsStorage.set("editSalesExId", "");
      this.$sessionsStorage.set("editMainEnqId", "");
      this.$router.push({
        path: "/viewDeleteRequestAssDetails/DeleteRequestAssDetails",
      });
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.mainSalesSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    openAirAssignmentModal(row) {
      this.$refs['AirAssignmentModal' + row.item.allModuleId].showModal();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    gotoDocs(item) {
      this.$router.push({
        path: "/allModule/docs/" + item,
      });
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL(CURRENT, "2", event);
    },
    filterSearch() {
      this.reload = false;
      this.viewFFExportFCL("0", "1");
    },
    getSalesAss(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName4 = "Downloading Please Wait .....";
      this.getAssignmentPendencyList("Excell", "0", "0", "1", "1");
    },
    getAssignmentPendencyList(type, filterId, currentPage, searchType, pageNumber) {

      let payload = {
        itemCode: "getBookingResp",
        type: type,
        page: 1,
        pageSize: 50,
        clientId: this.clientIdFilter,
        shipmentType: this.shipmentTypeFilter,
        transportType: this.transportTypeFilter,
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        LPfilter: this.LPfilter,
        PICKfilter: this.PICKfilter,
        HANDfilter: this.HANDfilter,
        STUFFfilter: this.STUFFfilter,
        shippingFilter: this.shippingFilter,
        enquiryFilter: this.enquiryFilter,
        assignmentFilter: this.assignmentFilter,
        containernoFilter: this.containernoFilter,
        shippingbillnoFilter: this.shippingbillnoFilter,
        validBookingNoFilter: this.validBookingNoFilter,
        continvoiceNoFilter: this.continvoiceNoFilter,
        commonFilter: this.commonFilter,
        vessleFilter: this.vessleFilter,
        fclLclFilter: this.fclLclFilter,
        statusFilter: this.statusFilter,
        jobFilter: this.jobFilter,
        branchfilter: this.branchfilter,
        airlineFilter: this.airlineFilter,
        containerFilter: this.containerFilter,
        fields: this.fields,
        fromSearch: 1,
        currentPage: 1,
        perPage: this.perPage,
        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        generateExcel: this.generateExcel,
        filter: {},
        isUserSummary: 0,
      };

      
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { } : {};
      // const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getAllSalesJobList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", response);

          if (status == 200 && data) {
            const grnList = data.data || [];
            console.log('exportJobListToExcel grnList=>',grnList)
          
          if (grnList.length > 0) {
            const fileName = `Job_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
            exportJobListToExcel(grnList, fileName);
            
            this.isLoading = false;
          } else {
            this.isLoading = false;
            alert('No data available to export');
          }
            // if (this.generateExcel == "1") {

            //   const blob = new Blob([data], {
            //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            //   });
            //   const url = window.URL.createObjectURL(blob);
            //   const link = document.createElement("a");
            //   link.href = url;
            //   link.setAttribute("download", "get-Job-Sales-panel-report.xlsx"); // Specify the file name
            //   document.body.appendChild(link);
            //   link.click();
            //   document.body.removeChild(link);

            //   this.ExcelBtnName4 = "Export Assignments";
            //   this.generateExcel = "0";
            //   this.viewFFExportFCL("0", "1");
            // } else {
            //   if (data.data.length > 0) {
            //     this.totalData = data.pagination.total;
            //     this.JOBList = data.data;
            //   }
            // }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getBookingResp Error: ", error);
        });
    },
    getReportsAss(id, btnName) {
      let excelIdGivin = "";
      if (id == "All_AdditionalTask_Excel") {
        excelIdGivin = "All_AdditionalTask_Excel";
        this.ExcelBtnName2 = "Downloading Please Wait...";
      } else if (id == "All_Expense_Excel") {
        excelIdGivin = "All_Expense_Excel";
        this.ExcelBtnName1 = "Downloading Please Wait...";
      } else {
        excelIdGivin = "DuplicateContainers";
        this.ExcelBtnName = "Downloading Please Wait...";
      }

      let payload = {
        excelId: id,
        clientId: this.clientIdFilter,
        shipmentType: this.shipmentTypeFilter,
        transportType: this.transportTypeFilter,
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        LPfilter: this.LPfilter,
        PICKfilter: this.PICKfilter,
        HANDfilter: this.HANDfilter,
        STUFFfilter: this.STUFFfilter,
        shippingFilter: this.shippingFilter,
        enquiryFilter: this.enquiryFilter,
        assignmentFilter: this.assignmentFilter,
        containernoFilter: this.containernoFilter,
        shippingbillnoFilter: this.shippingbillnoFilter,
        validBookingNoFilter: this.validBookingNoFilter,
        continvoiceNoFilter: this.continvoiceNoFilter,
        commonFilter: this.commonFilter,
        vessleFilter: this.vessleFilter,
        fclLclFilter: this.fclLclFilter,
        statusFilter: this.statusFilter,
        jobFilter: this.jobFilter,
        branchfilter: this.branchfilter,
        airlineFilter: this.airlineFilter,
        containerFilter: this.containerFilter,
        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
      };

      this.$store.dispatch("common/setAllPendingReverseTallyExcel", payload);
      let ExcelName = "";
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        if (id == "All_AdditionalTask_Excel") {
          this.ExcelBtnName2 = btnName;
        } else if (id == "All_Expense_Excel") {
          this.ExcelBtnName1 = btnName;
        } else {
          this.ExcelBtnName = btnName;
        }
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
    clearFilter() {
      this.shippingFilter = "";
      this.enquiryFilter = "";
      this.assignmentFilter = "";
      this.containernoFilter = "";
      this.shippingbillnoFilter = "";
      this.validBookingNoFilter = "";
      this.continvoiceNoFilter = "";
      this.commonFilter = "";
      this.vessleFilter = "";
      this.fclLclFilter = "";
      this.statusFilter = "3";
      this.jobFilter = "All";
      this.branchfilter = "";
      this.airlineFilter = "";
      this.containerFilter = "";
      this.clientIdFilter = "";
      this.transportTypeFilter = "";
      this.shipmentTypeFilter = "";

      this.PORfilter = "";
      this.PODfilter = "";
      this.LPfilter = "";
      this.PICKfilter = "";
      this.HANDfilter = "";
      this.STUFFfilter = "";
      this.viewFFExportFCL("0", "1");
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    proceedBilling(item) {
      this.$sessionsStorage.set("editSalesExId", item);
      this.$router.push({
        path: "/allModuleForm/billing/" + item,
      });
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    goRolloverCont() {
      this.$router.push({
        path: "/ctt/rollover-event",
      });
    },
    goShipmentTrack() {
      this.$router.push({
        path: "/ctt/subs-timeline-track",
      });
    },
    async execActions(allModuleId, id, series) {
      this.mailallModuleId = allModuleId;
      this.eventId = id;
      this.mailExecSeries = series;
      // alert(allModuleId)
      // let checkValueExit = await this.getPaymentExist(allModuleId);
      // // alert(checkValueExit);
      // if (checkValueExit) {
      //   this.alert.content =
      //     "Expenses have been Raised in this assignment are you sure you want to raise delete Request?";
      //   this.$refs["addPopMail"].open();
      //   return false;
      // }
      this.closeModalRemoveAss();
      if (id == "1") {
        this.alert.content = "Send Mail For Approval?";
        this.$refs["addPopMail"].open();
      }
      if (id == "2") {
        this.alert.content = "Are you sure you want to Approve?";
        this.$refs["addPopApprove"].open();
      }
      if (id == "3") {
        this.alert.content = "Are you sure you want to Reject?";
        this.$refs["addPopReject"].open();
      }
      if (id == "4") {
        this.alert.content = "Are you sure you want to delete this Execution ?";
        this.$refs["addPopDelete"].open();
      }
    },
    getPaymentExist(allModuleId) {
      this.PaymentType = "";
      return new Promise((resolve) => {
        let payload = {
          allModuleId: allModuleId,
          itemCode: "checkPaymentExist",
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Dashboard/getAllCSODash.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            console.log("data=>", data);
            this.PaymentType = "";
            if (status == 200 && data) {
              if (data.Payment_Status == "Yes") {
                this.invnoErrFlag = true;
                this.PaymentType = data.PaymentType;
              } else {
                this.invnoErrFlag = false;
              }
              return resolve(this.invnoErrFlag);
            }
          })
          .catch((error) => { });
      });
    },
    closeModalRemoveAss() {
      this.PaymentType = "";

      this.PaymentTypeModuleId = "";
      this.PaymentTypeID = "";
      this.PaymentTypeJOBNo = "";
      this.$refs["modal-AssRemove-conf"].hide();
    },

    async CompleteRemoveASS(allModuleId, id, series) {
      this.PaymentType = "";

      this.PaymentTypeModuleId = allModuleId;
      this.PaymentTypeID = id;
      this.PaymentTypeJOBNo = series;
      let checkValueExit = await this.getPaymentExist(allModuleId);
      if (checkValueExit) {
        this.PaymentType =
          "Expenses have been Raised in this assignment are you sure you want to raise delete Request?";
        this.$refs["modal-AssRemove-conf"].show();
      } else {
        this.execActions(allModuleId, id, series);
      }
    },

    onCloseAction(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let payload = {
          allModuleId: this.mailallModuleId,
          salesExecutionNo: this.mailExecSeries,
          eventId: this.eventId,
        };
        console.log(payload);

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/salesDeleteActions.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.viewFFExportFCL("0", "1", "1");
              this.isLoading = false;
            }
          })
          .catch((error) => { });
      }
    },
    // goToMain() {
    //   this.$sessionsStorage.set("editallModuleId", "");
    //   this.$router.push({
    //     path: "/allModuleForm/allModuleForm"
    //   });
    // },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportFCLConPage(AM, type) {
      this.$sessionsStorage.set("editSalesExId", AM);
      this.$sessionsStorage.set("editMainEnqId", "");

      if (type == "1") {
        this.$router.push({
          path: "/mainEnquiry/miscSalesExecutionAll",
        });
      } else {
        this.$router.push({
          path: "/mainEnquiry/salesExecutionAll",
        });
      }
    },
    viewExportMiscellaneous() {
      this.$sessionsStorage.set("editSalesExId", 12222);

      this.$router.push({
        path: "/mainEnquiry/miscellaneousExecutionAll",
      });
    },
    viewFFExportFCL(CURRENT, SEARCH, pageNumber) {
      this.consoBooking = [];
      this.branchList = [];
      this.isLoading = true;
      let payload = {
        clientId: this.clientIdFilter,
        shipmentType: this.shipmentTypeFilter,
        transportType: this.transportTypeFilter,
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        LPfilter: this.LPfilter,
        PICKfilter: this.PICKfilter,
        HANDfilter: this.HANDfilter,
        STUFFfilter: this.STUFFfilter,
        shippingFilter: this.shippingFilter,
        enquiryFilter: this.enquiryFilter,
        assignmentFilter: this.assignmentFilter,
        containernoFilter: this.containernoFilter,
        shippingbillnoFilter: this.shippingbillnoFilter,
        validBookingNoFilter: this.validBookingNoFilter,
        continvoiceNoFilter: this.continvoiceNoFilter,
        commonFilter: this.commonFilter,
        vessleFilter: this.vessleFilter,
        fclLclFilter: this.fclLclFilter,
        statusFilter: this.statusFilter,
        jobFilter: this.jobFilter,
        branchfilter: this.branchfilter,
        airlineFilter: this.airlineFilter,
        containerFilter: this.containerFilter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        filterUserId: this.$sessionsStorage.get('userId'),
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/viewAllModuleList_NewV3.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (data.assignmentData.length > 0) {
              this.consoBooking = data.assignmentData;
            } else {
              this.consoBooking = [];
            }
            if (data.branchList.length > 0) {
              this.branchList = data.branchList;
            } else {
              this.branchList = [];
            }
            // branchList
            this.isLoading = false;
            if (this.reload == true) {
              if (data.LocationDetailsFinal.length > 0) {
                this.finalAllPlaceDataPOR = data.LocationDetailsFinal;
                this.finalAllPlaceDataPOD = data.LocationDetailsFinal;
                this.finalAllPlaceDataLP = data.LocationDetailsFinal;
              }
              if (data.shippingList.length > 0) {
                this.shippingList = data.shippingList;
              }
              if (data.airlineList.length > 0) {
                this.airlineList = data.airlineList;
              }
              if (data.containerList.length > 0) {
                this.containerList = data.containerList;
              }
              if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
              }
            }
          }
        })
        .catch((error) => { });
    },
    goToSubscriptionPage(item) {
      if (item.SubscriptionId) {
        this.$router.push({
          path: "/tracking/ocean-insights/subscription/" + item.SubscriptionId,
        });
      }
    },
    activateUserMultiple(item, index) {
      // $("#approval" + id).val();
      let deleteArr = [];
      console.log("item=>", item);

      this.deleteId = item.allModuleId;
      this.itemObj.asignDeleted = item.asignDeleted == 1 ? 0 : 1;
      if (item.shipmentType == 2) {
        if (item.transportType == "Export") {
          deleteArr = [
            {
              tableName: "main_sales_execution",
              tableId: "allModuleId",
              tableIsActive: "asignDeleted",
              value1: this.itemObj.asignDeleted,
              tableVal: this.deleteId,
              isMailSend: "No",
              manual: "No",
            },
            {
              tableName: "air_freightexport",
              tableId: "allModuleId",
              tableIsActive: "asignDeleted",
              value1: this.itemObj.asignDeleted,
              tableVal: this.deleteId,
              isMailSend: "No",
              manual: "No",
            },
          ];
        } else if (item.transportType == "Import") {
          deleteArr = [
            {
              tableName: "main_sales_execution",
              tableId: "allModuleId",
              tableIsActive: "asignDeleted",
              value1: this.itemObj.asignDeleted,
              tableVal: this.deleteId,
              isMailSend: "No",
              manual: "No",
            },
            {
              tableName: "ff_air_import",
              tableId: "allModuleId",
              tableIsActive: "asignDeleted",
              value1: this.itemObj.asignDeleted,
              tableVal: this.deleteId,
              isMailSend: "No",
              manual: "No",
            },
          ];
        }
      } else {
        if (item.isConsolidation == "1" || item.isMiscJob == "1") {
          if (item.isConsolidation == "1") {
            deleteArr = [
              {
                tableName: "main_sales_execution",
                tableId: "allModuleId",
                tableIsActive: "asignDeleted",
                value1: this.itemObj.asignDeleted,
                tableVal: this.deleteId,
                isMailSend: "No",
                manual: "No",
              },
              {
                tableName: "frght_fclconsolidationexport",
                tableId: "allModuleId",
                tableIsActive: "asignDeleted",
                value1: this.itemObj.asignDeleted,
                tableVal: this.deleteId,
                isMailSend: "No",
                manual: "No",
              },
            ];
          }

          if (item.isMiscJob == "1") {
            deleteArr = [
              {
                tableName: "main_sales_execution",
                tableId: "allModuleId",
                tableIsActive: "asignDeleted",
                value1: this.itemObj.asignDeleted,
                tableVal: this.deleteId,
                isMailSend: "No",
                manual: "No",
              },
              {
                tableName: "misc_job_details",
                tableId: "allModuleId",
                tableIsActive: "asignDeleted",
                value1: this.itemObj.asignDeleted,
                tableVal: this.deleteId,
                isMailSend: "No",
                manual: "No",
              },
            ];
          }
        } else {
          let TableName;
          deleteArr = [
            {
              tableName: "main_sales_execution",
              tableId: "allModuleId",
              tableIsActive: "asignDeleted",
              value1: this.itemObj.asignDeleted,
              tableVal: this.deleteId,
              isMailSend: "No",
              manual: "No",
            },
          ];
          if (item.transportType == "Export") {
            if (item.jobType.indexOf("FF") >= 0) {
              TableName = "frght_ffexportfcl";
              let obj = {
                tableName: TableName,
                tableId: "allModuleId",
                tableIsActive: "asignDeleted",
                value1: this.itemObj.asignDeleted,
                tableVal: this.deleteId,
                isMailSend: "No",
                manual: "No",
              };
              deleteArr.push(obj);
            }

            if (item.jobType.indexOf("CC") >= 0) {
              TableName = "cc_export";
              let obj = {
                tableName: TableName,
                tableId: "allModuleId",
                tableIsActive: "asignDeleted",
                value1: this.itemObj.asignDeleted,
                tableVal: this.deleteId,
                isMailSend: "No",
                manual: "No",
              };
              deleteArr.push(obj);
            }
            if (item.jobType.indexOf("TPT") >= 0) {
              TableName = "quotationdetail";
              let obj = {
                tableName: TableName,
                tableId: "allModuleId",
                tableIsActive: "asignDeleted",
                value1: this.itemObj.asignDeleted,
                tableVal: this.deleteId,
                isMailSend: "No",
                manual: "No",
              };
              deleteArr.push(obj);
              TableName = "salesbookingdetail";
              let obj2 = {
                tableName: TableName,
                tableId: "allModuleId",
                tableIsActive: "asignDeleted",
                value1: this.itemObj.asignDeleted,
                tableVal: this.deleteId,
                isMailSend: "No",
                manual: "No",
              };
              deleteArr.push(obj2);
            }
          } else if (item.transportType == "Import") {
            if (item.jobType.indexOf("FF") >= 0) {
              TableName = "ff_sea_import";
              let obj = {
                tableName: TableName,
                tableId: "allModuleId",
                tableIsActive: "asignDeleted",
                value1: this.itemObj.asignDeleted,
                tableVal: this.deleteId,
                isMailSend: "No",
                manual: "No",
              };
              deleteArr.push(obj);
            }

            if (item.jobType.indexOf("CC") >= 0) {
              TableName = "cc_import";
              let obj = {
                tableName: TableName,
                tableId: "allModuleId",
                tableIsActive: "asignDeleted",
                value1: this.itemObj.asignDeleted,
                tableVal: this.deleteId,
                isMailSend: "No",
                manual: "No",
              };
              deleteArr.push(obj);
            }
            if (item.jobType.indexOf("TPT") >= 0) {
              TableName = "quotationdetail";
              let obj = {
                tableName: TableName,
                tableId: "allModuleId",
                tableIsActive: "asignDeleted",
                value1: this.itemObj.asignDeleted,
                tableVal: this.deleteId,
                isMailSend: "No",
                manual: "No",
              };
              deleteArr.push(obj);

              TableName = "salesbookingdetail";
              let obj2 = {
                tableName: TableName,
                tableId: "allModuleId",
                tableIsActive: "asignDeleted",
                value1: this.itemObj.asignDeleted,
                tableVal: this.deleteId,
                isMailSend: "No",
                manual: "No",
              };
              deleteArr.push(obj2);
            }
          }
        }
      }

      this.itemObj = item;
      this.indexNew = index;

      let payload = {
        deleteArr: deleteArr,
        secondSQLFlag: 1,
      };

      console.log("paylod =>", payload);
      MasterService.activeMultipleDetails(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200) {
            // this.isLoading = false;
            this.alert.content = data.msg;
            this.$refs["addPopMail"].open();
            this.getData("0", "0", "1", "1");
          }
        })
        .catch((error) => {
          console.log("Catch on sendSlinePaymentRequest Error: ", error);
        });

      // this.alert.content = true
      //   ? "Are you sure you want to Activate this User?"
      //   : "Are you sure you want to Deactivate this User?";
      // this.$refs["addPop6"].open();
    },
    SelectAll: function () {
      console.log("this.consoBooking=>", this.consoBooking);
      this.isCheckAll = !this.isCheckAll;
      this.AllModule_ids = [];
      this.AllJob_Nos = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.consoBooking) {
          if (this.consoBooking[key].finalBillingCompleted != 1) {
            this.AllModule_ids.push(this.consoBooking[key].allModuleId);
            this.AllJob_Nos.push(this.consoBooking[key].mainSalesSeries);
          }
        }
        console.log("this.AllModule_ids=>", this.AllModule_ids);
        console.log("this.AllJob_Nos=>", this.AllJob_Nos);
      }
    },
    updateSelectAll: function (e, item) {
      console.log("ids", e);
      console.log("ids", item);
      if (this.AllModule_ids.length == this.consoBooking.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }

      const istrue = this.AllModule_ids.includes(item.allModuleId);
      if (istrue == true) {
        this.AllJob_Nos.push(item.mainSalesSeries);
      } else {
        const index = this.AllJob_Nos.indexOf(item.mainSalesSeries);
        this.AllJob_Nos.splice(index, 1);
      }

      console.log("this.AllModule_ids=>", this.AllModule_ids);
      console.log("this.AllJob_Nos=>", this.AllJob_Nos);
    },
    viewExportEnqPage(AM) {
      if (
        this.$sessionsStorage.get("finalPagePermision").split(",").indexOf("Enquiry") >= 0
      ) {
        this.$sessionsStorage.set("editMainFilterEnqId", AM);

        this.$router.push({
          path: "/viewMainEnquiryDetails/viewMainEnquiryDetails",
        });
      }
    },
    DeleteTypeFunc(type) {
      this.DeleteType = type;
    },
    removeExpInv() {
      if (this.AllModule_ids.length > 0) {
        this.$refs["modal-INVEXP-conf"].show();
      }
    },
    closeModalRemoveExpInv() {
      this.$refs["modal-INVEXP-conf"].hide();
    },
    CompleteRemoveExpInv() {
      this.isLoading = true;
      let AllModule_ids_arr = this.AllModule_ids;
      let AllJob_Nos_arr = this.AllJob_Nos;

      let payload = {
        itemCode: "removeExpInvModuleBased",
        allModuleID: AllModule_ids_arr,
        JobNo: AllJob_Nos_arr,
        DeleteType: this.DeleteType,
      };

      console.log("paylod =>", payload);
      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200) {
            this.isLoading = false;
            this.alert.content = data.msg;
            this.$refs["addPopMail"].open();
            this.getData("0", "0", "1", "1");
            this.$refs["modal-INVEXP-conf"].hide();
          }
        })
        .catch((error) => {
          console.log("Catch on removeExpInv Error: ", error);
        });
    },
  },
};
</script>
<style>
.alert-danger-text {
  /* background-color: #d9534f; Bootstrap danger color */
  color: #d9534f;
  /* Bootstrap danger color */
}

@keyframes blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1s infinite;
  /* Adjust the duration as needed */
}
</style>



// WEBPACK FOOTER //
// viewAllModuleDetails.vue?031e8e0d